<template>
  <div class="location-stars">
    <div class="location-stars--active" :style="{ width: `${value * 20}%` }"></div>
  </div>
</template>

<script>
export default {
  name: 'LocationStars',
  props: {
    value: {
      type: Number,
      required: true,
    },
  },
}
</script>

<style lang="scss" scoped>
.location-stars {
  background-image: url('~@/assets/img/ratings/star-empty.svg');
  background-repeat: repeat-x;
  background-size: 24px auto;

  &--active {
    background-image: url('~@/assets/img/ratings/star-full.svg');
    background-repeat: repeat-x;
    background-size: 24px auto;
    height: 24px;
  }
}
</style>
